/** Business-dialect overrides. Sparse: a missing key falls back to en. */
export const omnibox = {
    destinations: {
        pageKeywords: {
            clients: 'client projects contacts people',
        },
        settingsTabKeywords: {
            practice: 'business company profile details logo name address',
        },
        sections: {
            matterReference: {
                keywords: 'prefix number numbering project reference',
            },
            csvImportExport: {
                keywords: 'csv spreadsheet upload download clients projects activities invoices',
            },
        },
    },
    groups: {
        matters: 'Projects',
        recentMatters: 'Recent projects',
        newestMatters: 'Newest projects',
    },
    noMatches: 'No clients, projects or invoices match "{{query}}". Try asking Bill instead.',
    noMatchesWithoutInvoices: 'No clients or projects match "{{query}}". Try asking Bill instead.',
};
